import _objectWithoutProperties from "/home/maxwell/maxwell-sms-shopify-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import React from 'react';
import { UnstyledButton } from './UnstyledButton.js';

function unstyledButtonFrom(_ref, overrides, key) {
  var content = _ref.content,
      onAction = _ref.onAction,
      action = _objectWithoutProperties(_ref, ["content", "onAction"]);

  return (
    /*#__PURE__*/
    React.createElement(UnstyledButton, Object.assign({
      key: key,
      onClick: onAction
    }, action, overrides), content)
  );
}

export { unstyledButtonFrom };